const is = (a, b) => a === b;
export default is;
